module.exports = __webpack_public_path__ + "img/shape_arrows_reverse.2c2c0d21.png";